import React, {useRef, useState} from 'react';
import {Card, Form, Button, Space, DatePicker, Typography, Select} from "antd";
import dayjs from "dayjs";
import {DeleteOutlined, LoadingOutlined, SaveOutlined} from "@ant-design/icons";
import useBackendUsers from "../../../../providers/mortgage/useBackendUsers";
import isEqual from "lodash/isEqual";
import {ApplicationStages} from "../../../../../models";
function StageAndRequiredRangeSetter({section}) {
    const [form] = Form.useForm();
    const [dirty, setDirty] = useState(false);
    const [saving, setSaving] = useState(false);
    const initialValues = {
        ranges: section?.progress?.requiredRanges || [],
        userStages: section?.progress?.userStages || []
    }
    const initialRef = useRef(initialValues);
    const { me} = useBackendUsers();

    const handleChange = (_, allValues) => {
        setDirty(!isEqual(allValues, initialRef.current));
    };
    const onFinish = async (values) => {
        const cleaned = {
            ...values,
            ranges: values.ranges.map(r => ({
                start: r.start?.format("YYYY-MM-DD"),
                end: r.end?.format("YYYY-MM-DD"),
            })),
        };
        if (!cleaned.ranges.length) {
            cleaned.ranges = null
        }
        if (section.progress) {
            setSaving(true);
            await section.mortgage.mutate({
                update: {
                    target: `progress[${section.progress.id}]`,
                    pairs: {
                        userStages: cleaned.userStages,
                        requiredRanges: cleaned.ranges,
                        requiredRangesAuthor: me?.sub
                    }
                }
            }, ()=>{setDirty(false); setSaving(false)});
        }
    }
    const message = section.progress.requiredRanges?.length ? `Min Period Required` : "Min Period Required";
    return (


            <Form
                form={form}
                onValuesChange={handleChange}
                initialValues={{
                    ranges: initialValues.ranges.map(r => ({
                        start: r.start ? dayjs(r.start) : null,
                        end: r.end ? dayjs(r.end) : null,
                    })) || [],
                    userStages: initialValues.userStages || []
                }}
                onFinish={onFinish}
            >
                <div className="d-col me-auto">
                    <strong>Show in Stages</strong>
                </div>
                <Form.Item name="userStages" className="mb-3">
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        placeholder="Select options"
                        options={[
                            { label: 'Apply', value: ApplicationStages.APPLY },
                            { label: 'Pre-Approval', value: ApplicationStages.PREAPPROVAL },
                            { label: 'Pre-Approval Extending', value: ApplicationStages.PREAPPROVAL_EXTENDING },
                            { label: 'Approval', value: ApplicationStages.APPROVAL },
                            { label: 'Approval Extending', value: ApplicationStages.APPROVAL_EXTENDING },
                        ]}
                    />
                </Form.Item>
                <div className="d-col me-auto">
                    <strong>{message}</strong>
                </div>
                <Form.List name="ranges">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <Space key={key} style={{ display: "flex", marginBottom: 8 }}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, "start"]}
                                        className="mb-0"
                                        rules={[{ required: true, message: "Start required" }]}
                                    >
                                        <DatePicker placeholder="Start date" format="DD MMM YYYY"
                                                    inputReadOnly/>
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        name={[name, "end"]}
                                        className="mb-0"
                                        rules={[{ required: true, message: "End required" }]}
                                    >
                                        <DatePicker
                                            format="DD MMM YYYY"
                                            inputReadOnly
                                            placeholder="End date"
                                        />
                                    </Form.Item>

                                    <Button danger onClick={() => remove(name)}>
                                        <DeleteOutlined />
                                    </Button>
                                    {
                                        name === fields.length - 1 && FormListControl({add,dirty, saving, fieldsLength: fields.length})
                                    }
                                </Space>
                            ))}
                            {
                                fields.length === 0 && <div className="d-row gap-9">{FormListControl({add,dirty, saving, fieldsLength: fields.length})}</div>
                            }
                        </>
                    )}
                </Form.List>


            </Form>

    );
}

function FormListControl({dirty, add, saving, fieldsLength }){
    const items = []
    if (fieldsLength === 0) {
        items.push( <Button key="add" type="dashed" onClick={() => add()}>
            Add Range
        </Button>)
    }


    if (dirty){
        items.push( <Button type={saving ? "default":"primary"} danger key="save" icon={saving ? <LoadingOutlined/> : <SaveOutlined/>} htmlType="submit" >
            Save
        </Button>)
    }
    return items
}
export default StageAndRequiredRangeSetter;